import React from 'react';
import classnames from 'classnames';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import s from './BaseTierUpsell.scss';
export const BaseTierUpsell = ({ imageSrc, imageWidth, title, subtitle, href, buttonText, className, biData, onClick })=>{
    return /*#__PURE__*/ React.createElement(Section, {
        className: classnames(s['root'], className)
    }, imageSrc && imageWidth && /*#__PURE__*/ React.createElement("img", {
        src: imageSrc,
        alt: "",
        width: imageWidth
    }), title && /*#__PURE__*/ React.createElement(Heading, {
        className: s['title']
    }, title), subtitle && /*#__PURE__*/ React.createElement("p", {
        className: s['subtitle']
    }, subtitle), (href || onClick) && buttonText && /*#__PURE__*/ React.createElement(GhostButton, {
        className: s['button'],
        size: "medium",
        variant: "main",
        href: href,
        onClick: onClick,
        biData: biData
    }, buttonText));
};
BaseTierUpsell.displayName = 'BaseTierUpsell';
export default BaseTierUpsell;

//# sourceMappingURL=BaseTierUpsell.js.map